import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ProgramService } from '../../../../services/aws/program/program.service';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';
import { ReportService } from 'src/app/services/aws/report/report.service';
import { IParticipant } from 'src/app/models/IParticipant';
import { IErrorMessage } from 'src/app/widgets/error-message/error-message.interface';
import { API_USER_DEFINED_MESSAGE } from 'src/app/widgets/error-message/error-message.const';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/widgets/confirm-dialog/confirm-dialog.component';
import { Observable } from 'rxjs';
import {
    MatSnackBar,
    MatSnackBarHorizontalPosition,
    MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { OrderByPipe } from 'src/app/widgets/pipes/orderby.pipe';

@Component({
    selector: 'program-registration',
    templateUrl: './registration.component.html',
    styleUrls: ['./registration.component.scss'],
    providers: [OrderByPipe],
    standalone: false
})
export class RegistrationComponent implements OnInit {

    @Input()
    parentSpinner: boolean;

    mode: string = 'view';
    searchmode: string = 'open';
    programId: any;
    participants: IParticipant[];
    public errorMessage: IErrorMessage = {};
    isDesc: boolean = false;
    column: string = 'lastName';
    direction: number = 1;
    isLastNameAsc: boolean = false;
    isEmailAsc: boolean = false;
    isHotelStatusAsc: boolean = false;
    isCourseStatusAsc: boolean = false;
    isFlightArrivalStatusAsc: boolean = false;
    isFlightDepartureStatusAsc: boolean = false;
    isInviteeStatusAsc: boolean = false;
    isRegistrationTypeAsc: boolean = false;
    isUserPrivateAsc: boolean = false;
    programName: string;
    sDate: any;
    eDate: any;
    showLoading: boolean = false;
    public isDateSort: boolean = false;
    acceptedStatusCount: number;
    selectedFilter: string = 'all';
    allParticipants: IParticipant[];
    selectedItems: Set<string> = new Set();

    horizontalPosition: MatSnackBarHorizontalPosition = 'center';
    verticalPosition: MatSnackBarVerticalPosition = 'top';

    constructor(
        private programservice: ProgramService,
        private reportService: ReportService,
        private route: ActivatedRoute,
        private dialog: MatDialog,
        private snackBar: MatSnackBar,
        private orderByPipe: OrderByPipe,
        private cdr: ChangeDetectorRef
    ) {
        this.route.params.pipe(take(1)).subscribe(params => {
            this.programId = params['id'];
        });
    }

    ngOnInit() {
        this.getList();
    }

    public getList() {
        this.errorMessage = {};
        this.showLoading = this.parentSpinner;
        this.programservice.getParticipantsByProgram(this.programId)
            .subscribe((response: IParticipant[]) => {
                this.showLoading = false;
                this.errorMessage.text = response?.length ? '' : API_USER_DEFINED_MESSAGE.EMPTY_RESPONSE;
                this.acceptedStatusCount = 0;
                response.forEach((participant: IParticipant) => {
                    this.normalizeParticipant(participant);
                    if (participant?.hotelStatus === 'Declined Room') {
                        participant.hotelStatus = 'Declined';
                    }
                    if (participant?.inviteeStatus === 'Accepted') {
                        this.acceptedStatusCount++;
                    }
                });
                this.allParticipants = response;
                this.participants = response;
                this.selectedItems.clear();
                this.updateDisplayError();
            },
                () => {
                    this.showLoading = false;
                    this.participants = [];
                    this.allParticipants = [];
                    this.errorMessage.text = API_USER_DEFINED_MESSAGE.FAILED;
                });
    }

    toggleRegistration() {
        this.mode = this.mode != 'edit' ? 'edit' : 'view';
        this.searchmode = this.searchmode != 'close' ? 'close' : 'open';
        if (this.mode == 'edit' && this.participants != undefined) {
            this.participants = this.participants.filter(x => x.hotel != null && x.hotel.status != null && x.hotel.status.toUpperCase() == 'WAITLIST');
        } else {
            this.getList();
        }
    }

    sort(property, event) {
        event.stopPropagation();
        this.isDesc = !this.isDesc;
        this.column = property;
        this.direction = this.isDesc ? 1 : -1;
        this.isDateSort = false;
        switch (property) {
            case 'lastName':
                this.isLastNameAsc = !this.isLastNameAsc;
                break;
            case 'email':
                this.isEmailAsc = !this.isEmailAsc;
                break;
            case 'hotelStatus':
                this.isHotelStatusAsc = !this.isHotelStatusAsc;
                break;
            case 'courseStatus':
                this.isCourseStatusAsc = !this.isCourseStatusAsc;
                break;
            case 'flightArrival':
                this.isFlightArrivalStatusAsc = !this.isFlightArrivalStatusAsc;
                this.isDateSort = true;
                break;
            case 'flightDeparture':
                this.isFlightDepartureStatusAsc = !this.isFlightDepartureStatusAsc;
                this.isDateSort = true;
                break;
            case 'inviteeStatus':
                this.isInviteeStatusAsc = !this.isInviteeStatusAsc;
                break;
            case 'registrationType':
                this.isRegistrationTypeAsc = !this.isRegistrationTypeAsc;
                break;
            case 'isUserPrivate':
                this.isUserPrivateAsc = !this.isUserPrivateAsc;
                break;
        }
    }

    download() {
        this.reportService.getRegistrationStatusReport(this.programId);
    }

    onFilterChange() {
        this.updateDisplayError();
    }

    getDisplayParticipants(): IParticipant[] {
        const list = this.getFilteredParticipants();
        return this.orderByPipe.transform([...list], {
            property: this.column,
            direction: this.direction,
            isDateSort: this.isDateSort
        }) || [];
    }

    getFilteredParticipants(): IParticipant[] {
        let list = this.allParticipants || [];
        if (this.selectedFilter === 'accepted') {
            list = list.filter((item) => item?.inviteeStatus === 'Accepted');
        }
        return list;
    }

    canToggleIndividualVisibility(participant: IParticipant): boolean {
        return this.canManagePrivacy(participant) && !this.isBulkSelectionActive();
    }

    isBulkSelectionActive(): boolean {
        return this.selectedItems.size > 0;
    }

    clearSelection(): void {
        this.selectedItems.clear();
    }

    getBulkSelectionSummary(): string {
        const selected = [...this.selectedItems]
            .map((id) => this.findParticipantById(id))
            .filter((participant): participant is IParticipant =>
                !!participant && this.canManagePrivacy(participant));
        if (!selected.length) {
            return '';
        }
        const hiddenCount = selected.filter((participant) => this.isParticipantHidden(participant)).length;
        const visibleCount = selected.length - hiddenCount;
        return `${visibleCount} visible, ${hiddenCount} hidden`;
    }

    toggleParticipantVisibility(participant: IParticipant) {
        if (!this.canToggleIndividualVisibility(participant)) {
            return;
        }
        const participantId = this.resolveParticipantId(participant);
        if (!participantId) {
            return;
        }
        if (!this.isParticipantHidden(participant)) {
            this.openConfirmDialog('Are you sure you want to hide this registrant from attendee lists?')
                .pipe(take(1))
                .subscribe((result) => {
                    if (result) {
                        this.updatePrivacy([participantId], true);
                    }
                });
        } else {
            this.updatePrivacy([participantId], false);
        }
    }

    canManagePrivacy(participant: IParticipant): boolean {
        return participant?.isUserPrivate !== 'NA';
    }

    isPrivacyNotApplicable(participant: IParticipant): boolean {
        return participant?.isUserPrivate === 'NA';
    }

    isParticipantHidden(participant: IParticipant): boolean {
        return participant?.isUserPrivate === 'true';
    }

    resolveParticipantId(participant: IParticipant): string | null {
        const raw = participant?.participantId ?? participant?.id;
        if (raw === null || raw === undefined || raw === '') {
            return null;
        }
        return String(raw);
    }

    isSelected(participant: IParticipant): boolean {
        const id = this.resolveParticipantId(participant);
        return !!id && this.selectedItems.has(id);
    }

    toggleSelection(participant: IParticipant) {
        if (!this.canManagePrivacy(participant)) {
            return;
        }
        const id = this.resolveParticipantId(participant);
        if (!id) {
            return;
        }
        if (this.selectedItems.has(id)) {
            this.selectedItems.delete(id);
        } else {
            this.selectedItems.add(id);
        }
    }

    areAllVisibleRowsChecked(): boolean {
        const manageable = this.getManageableParticipants();
        return manageable.length > 0 && manageable.every((item) => this.isSelected(item));
    }

    toggleSelectAll(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        const manageable = this.getManageableParticipants();
        if (isChecked) {
            manageable.forEach((item) => {
                const id = this.resolveParticipantId(item);
                if (id) {
                    this.selectedItems.add(id);
                }
            });
        } else {
            manageable.forEach((item) => {
                const id = this.resolveParticipantId(item);
                if (id) {
                    this.selectedItems.delete(id);
                }
            });
        }
    }

    private getManageableParticipants(): IParticipant[] {
        return this.getFilteredParticipants().filter((item) => this.canManagePrivacy(item));
    }

    canBulkHide(): boolean {
        return [...this.selectedItems].some((id) => {
            const participant = this.findParticipantById(id);
            return participant && this.canManagePrivacy(participant) && !this.isParticipantHidden(participant);
        });
    }

    canBulkShow(): boolean {
        return [...this.selectedItems].some((id) => {
            const participant = this.findParticipantById(id);
            return participant && this.canManagePrivacy(participant) && this.isParticipantHidden(participant);
        });
    }

    bulkHide() {
        const ids = this.getSelectedIdsForPrivacy(false);
        if (!ids.length) {
            return;
        }
        this.openConfirmDialog('Are you sure you want to hide the selected registrant(s) from attendee lists?')
            .pipe(take(1))
            .subscribe((result) => {
                if (result) {
                    this.updatePrivacy(ids, true);
                }
            });
    }

    bulkShow() {
        const ids = this.getSelectedIdsForPrivacy(true);
        if (!ids.length) {
            return;
        }
        this.updatePrivacy(ids, false);
    }

    private updateDisplayError() {
        const visible = this.getFilteredParticipants();
        if (this.selectedFilter === 'accepted' && !visible.length) {
            this.errorMessage.text = API_USER_DEFINED_MESSAGE.EMPTY_ACCEPTED_STATUS;
        } else if (!this.allParticipants?.length) {
            this.errorMessage.text = API_USER_DEFINED_MESSAGE.EMPTY_RESPONSE;
        } else {
            this.errorMessage.text = '';
        }
    }

    trackParticipant(_index: number, participant: IParticipant): string {
        return this.resolveParticipantId(participant) ?? participant?.email ?? String(_index);
    }

    private normalizeParticipant(participant: IParticipant): void {
        const resolvedId = this.resolveParticipantId(participant);
        if (resolvedId) {
            participant.participantId = Number(resolvedId);
        }
    }

    private findParticipantById(id: string): IParticipant | undefined {
        return this.allParticipants?.find((participant) => this.participantMatchesId(participant, id));
    }

    private getSelectedIdsForPrivacy(hiddenOnly: boolean): string[] {
        return [...this.selectedItems].filter((id) => {
            const participant = this.findParticipantById(id);
            if (!participant || !this.canManagePrivacy(participant)) {
                return false;
            }
            return hiddenOnly ? this.isParticipantHidden(participant) : !this.isParticipantHidden(participant);
        });
    }

    private participantMatchesId(participant: IParticipant, targetId: string): boolean {
        const candidates = [
            participant?.participantId,
            participant?.id,
            this.resolveParticipantId(participant)
        ]
            .filter((value) => value != null && value !== '')
            .map((value) => String(value));
        return candidates.includes(targetId);
    }

    private updatePrivacy(participantIds: string[], isUserPrivate: boolean) {
        this.showLoading = true;
        this.programservice.updateParticipantPrivacy(this.programId, participantIds, isUserPrivate)
            .subscribe(() => {
                this.showLoading = false;
                this.selectedItems.clear();
                const message = isUserPrivate
                    ? 'Registrant(s) hidden from attendee lists.'
                    : 'Registrant(s) are now visible in attendee lists.';
                this.snackBar.open(message, 'OK', {
                    duration: 5000,
                    horizontalPosition: this.horizontalPosition,
                    verticalPosition: this.verticalPosition,
                    panelClass: ['success-snackbar']
                });
                this.getList();
            },
                () => {
                    this.showLoading = false;
                    this.refreshParticipantLists();
                    this.snackBar.open('Something went wrong, please try again later.', 'OK', {
                        duration: 8000,
                        horizontalPosition: this.horizontalPosition,
                        verticalPosition: this.verticalPosition,
                        panelClass: ['error-snackbar']
                    });
                });
    }

    private refreshParticipantLists() {
        this.allParticipants = [...(this.allParticipants || [])];
        this.participants = [...(this.participants || [])];
        this.cdr.detectChanges();
    }

    private openConfirmDialog(body: string): Observable<boolean> {
        return this.dialog.open(ConfirmDialogComponent, {
            data: {
                title: '',
                body,
                buttonTextNo: 'Cancel',
                buttonTextYes: 'Yes, continue'
            },
            panelClass: 'notification-submit-dialog',
            disableClose: true
        }).afterClosed();
    }
}
